import { render, staticRenderFns } from "./Degree.vue?vue&type=template&id=f7b1f85e&scoped=true&"
import script from "./Degree.vue?vue&type=script&lang=js&"
export * from "./Degree.vue?vue&type=script&lang=js&"
import style0 from "./Degree.vue?vue&type=style&index=0&id=f7b1f85e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7b1f85e",
  null
  
)

export default component.exports